/**
 * 主题状态管理 (Zustand)
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ThemeMode = 'system' | 'light' | 'dark' | 'geek' | 'hlight' | 'hdark' | 'cyber' | 'tech' | 'blue'

interface ThemeState {
  hydrated: boolean
  themeMode: ThemeMode
  setHydrated: (hydrated: boolean) => void
  setThemeMode: (mode: ThemeMode) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      hydrated: false,
      themeMode: 'system',
      setHydrated: (hydrated) => set({ hydrated }),
      setThemeMode: (mode) => set({ themeMode: mode }),
    }),
    {
      name: 'theme-storage',
      onRehydrateStorage: () => (state) => {
        state?.setHydrated(true)
      },
      partialize: (state) => ({ themeMode: state.themeMode }),
    }
  )
)
